module.exports = __webpack_public_path__ + "img/pos3-bg.b297e3fa.jpg";